import React from 'react';
import styles from './Modal.module.css';
import { FaTimes } from 'react-icons/fa';
import Modal from "./Modal";

function ModalConfirm({ onClose, onConfirm, message = "Confirmer ?" }) {

    return (
        <Modal onClose={onClose} className={styles.modalConfirm}>
            <div style={{padding: "20px"}}>
                <h3 className={"titleAlert"}>{message}</h3>
                <div className={styles.btnChoiceBar}>
                    <button onClick={onClose} className="btn btn_primary">Annuler</button>
                    <button onClick={onConfirm} className="btn btn_main">Confirmer</button>
                </div>
            </div>
        </Modal>
    );
}

export default ModalConfirm;
